<div class="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900 py-12 px-4 sm:px-6 lg:px-8">
  <div class="max-w-md w-full space-y-8">
    <div>
      <h1 class="mt-6 text-center text-3xl font-extrabold text-gray-900 dark:text-white" data-testid="login-title">OCR Prime Admin</h1>
      <p class="mt-2 text-center text-sm text-gray-600 dark:text-gray-300">Please sign in to access the admin dashboard</p>
    </div>

    @if (sessionExpired) {
      <div
        role="alert"
        data-testid="login-session-expired"
        class="rounded-md border border-amber-300 bg-amber-50 px-4 py-3 text-sm text-amber-900 dark:border-amber-700 dark:bg-amber-950 dark:text-amber-100"
      >
        Your session has expired. Please sign in again to continue where you left off.
      </div>
    }

    <button
      data-testid="login-sign-in-btn"
      class="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 dark:bg-indigo-700 dark:hover:bg-indigo-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 dark:focus:ring-indigo-400 dark:focus:ring-offset-gray-900 disabled:opacity-50 disabled:cursor-not-allowed"
      (click)="login()"
      [disabled]="isLoading"
    >
      @if (!isLoading) {
        <span>Sign In with Cognito</span>
      }
      @if (isLoading) {
        <span>Redirecting to login...</span>
      }
    </button>
  </div>
</div>
